import React, {useEffect, useState} from "react";
import "./VisitLogTable.sass"
import {useParams} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import Spinner from "../../../../pages/common/anonymous/Spinner";
import {getLog, saveAllVisits} from "../../../../_actions/group/groupService";
import _ from 'lodash';
import moment from 'moment';
import VisitItem from "./VisitItem";
import ButtonComponent from "../../../common/buttons/ButtonComponent";
import {useSnackbar} from 'notistack';
import CheckIcon from "@mui/icons-material/Check";
import HMobiledataIcon from '@mui/icons-material/HMobiledata';
import {CropSquare} from "@mui/icons-material";
import {FAILED, IDLE, SUCCESS} from "../../../../common/statuses";

export default function VisitLogTable() {
    const {id} = useParams()

    const {enqueueSnackbar} = useSnackbar()

    const [isEditable, setIsEditable] = useState(false);
    const [visitState, setVisitState] = useState({});

    const {data, status} = useSelector(state => state.groups.getLog);
    const {data: group, status: groupStatus} = useSelector(state => state.groups.selected);
    const {status: saveVisitsStatus, message} = useSelector(state => state.groups.saveVisits);
    const dispatch = useDispatch();

    useEffect(() => {
        if (status === IDLE && groupStatus === SUCCESS) {
            dispatch(getLog(id))
        }
        if (status === SUCCESS) {
            setTimeout(() => {
                const elementById = document.getElementById("VisitLog-current-id");
                if (elementById !== null) {
                    elementById.focus()
                }
            }, 50)
        }
    }, [status, groupStatus, data, dispatch])
    useEffect(() => {
        if (saveVisitsStatus === FAILED) {
            enqueueSnackbar(message, {variant: "error"})
        }
        if (saveVisitsStatus === SUCCESS) {
            enqueueSnackbar(message, {variant: "success"})
        }
    }, [saveVisitsStatus, message, dispatch])


    if (status === IDLE) {
        return <Spinner/>
    }

    const {dates, students, visits} = data

    if (_.isEmpty(dates)) {
        return (
            <div className="VisitLog-wrapper">
                <div className="VisitLog-content">
                    <div className="VisitLog-schedule-is-not-created">
                        {
                            _.isEmpty(group.students) ? "Ученики ещё не добавлены" : "Расписание ещё не создано"
                        }
                    </div>
                </div>
            </div>
        )

    }

    const handleSave = (item) => {
        let newValue;
        let v = visitState[item.id] || visits.filter(o => o.id === item.id)[0];
        if (v) {
            if (v.isVisited === null) {
                newValue = true;
            } else if (v.isVisited) {
                newValue = false
            } else {
                newValue = null;
            }

            setVisitState({
                ...visitState,
                [item.id]: {
                    ...v,
                    isVisited: newValue
                }
            })
        }
    }

    const renderStudentVisit = (currentStudent) => {
        let res = [];
        dates.forEach(date => {
            const r = visits.filter(visit => {
                const {student, lesson} = visit;
                return student.id === currentStudent.id && lesson.date === date
            })[0];

            res = [...res, r];
        })

        return (
            <div key={`VisitLog-visits-item-${currentStudent.id}`}
                 className="VisitLog-visits-item VisitLog-border">
                {
                    res.map((item, i) => {
                        return item ? <VisitItem key={`VisitItem-${item.id}`}
                                                 isCanceled={item.lesson && item.lesson.isCanceled}
                                                 editable={item.lesson && item.lesson.isCanceled ? false : isEditable}
                                                 onClick={() => handleSave(item)}
                                                 visit={visitState[item.id] || item}/>
                            : <VisitItem key={`VisitItem-not-${currentStudent.id}-${i}`}
                                         isCanceled={item && item.lesson && item.lesson.isCanceled}
                                         editable={false}/>
                    })
                }
            </div>
        )
    }

    const renderNames = (student) => {
        return (
            <div key={`VisitLog-name-${student.id}`} className="VisitLog-name VisitLog-border">
                <div className="VisitLog-name-text">
                    {student.lastName + " " + student.firstName}
                </div>
            </div>
        )
    }

    return (
        <div className="VisitLog-wrapper">
            <div className="VisitLog-content">
                <div className="VisitLog-data">
                    <div className="VisitLog-names">
                        <div style={{
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRight: '1px solid white',
                            borderTop: '1px solid white'
                        }}
                             className="VisitLog-header">Ученик
                        </div>
                        <div>
                            {students && [...students].sort((a, b) => {
                                const aName = `${a.lastName} ${a.firstName} ${a.middleName} ${a.id}`
                                const bName = `${b.lastName} ${b.firstName} ${b.middleName} ${b.id}`
                                return aName.localeCompare(bName)
                            }).map(renderNames)}
                        </div>
                    </div>
                    <div className="VisitLog-dates">
                        <div>
                            <div className="VisitLog-header">
                                {dates && dates.map((date, i) =>
                                    <div key={`VisitLog-header-${i}`}
                                         id={i === dates.length-4 ? "VisitLog-current-id" : undefined}
                                         className="VisitLog-date"
                                         tabIndex={i === dates.length-4 ? 1 : -1}>
                                        {moment(date, "YYYY-MM-DD").format("DD.MM")}
                                    </div>
                                )}
                            </div>
                            <div className="VisitLog-visits VisitLog-with-select">
                                {
                                    students && [...students].sort((a, b) => {
                                        const aName = `${a.lastName} ${a.firstName} ${a.middleName} ${a.id}`
                                        const bName = `${b.lastName} ${b.firstName} ${b.middleName} ${b.id}`
                                        return aName.localeCompare(bName)
                                    }).map(renderStudentVisit)
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="VisitLog-legend">
                    <div className="VisitLog-legend-icons">
                        <div>
                            <CheckIcon/> - присутствовал
                        </div>
                        <div>
                            <HMobiledataIcon/> - отсутствовал
                        </div>
                        <div>
                            <CropSquare/> - не указано
                        </div>
                    </div>
                    <div className="VisitLog-legend-events">
                        <div>
                            <div style={{
                                width: '1.5em',
                                height: '1.5em',
                                backgroundColor: 'rgba(225, 109, 147, 0.2)'
                            }}></div>
                            - отменённое занятие
                        </div>
                        <div>
                            <div style={{
                                width: '1.5em',
                                height: '1.5em',
                                backgroundColor: 'rgba(85, 204, 120, 0.3)'
                            }}></div>
                            - текущее занятие
                        </div>
                    </div>
                </div>
                <div className="VisitLog-bottom">
                    {
                        isEditable
                            ? <div style={{display: 'flex', gap: '1em'}}>
                                <ButtonComponent onClick={() => {
                                    const values = Object.values(visitState);
                                    setIsEditable(false)
                                    dispatch(saveAllVisits(values))
                                }}>
                                    Сохранить
                                </ButtonComponent>
                                <ButtonComponent onClick={() => {
                                    setIsEditable(false)
                                    setVisitState({})
                                }}>
                                    Отменить
                                </ButtonComponent>
                            </div>
                            : <ButtonComponent onClick={() => setIsEditable(true)}>
                                Редактировать
                            </ButtonComponent>
                    }
                </div>
            </div>
        </div>
    )
}